import React from "react";

/**
 * Skeleton placeholder for PlanCard.
 * Mirrors PlanCard's structure 1:1 (icon+name+type, price, benefit chip
 * row, footer link) at matching size/padding so the grid doesn't
 * reflow/jump when real plans replace the skeleton.
 */
const PlanCardSkeleton = () => {
  return (
    <div
      className="relative w-full min-h-[250px] rounded-2xl border border-[#E8E5F0] bg-white p-4 pr-8"
      aria-hidden="true"
    >
      {/* Icon + plan name + type/members line */}
      <div className="flex items-start gap-2.5">
        <div className="h-12 w-12 shrink-0 rounded-xl bg-[#EFEDF4] animate-pulse" />
        <div className="min-w-0 flex-1 pt-0.5 space-y-2">
          <div className="h-4 w-3/4 rounded-full bg-[#EFEDF4] animate-pulse" />
          <div className="h-3 w-2/5 rounded-full bg-[#EFEDF4] animate-pulse" />
        </div>
      </div>

      {/* Price */}
      <div className="mt-3">
        <div className="h-6 w-24 rounded-full bg-[#EFEDF4] animate-pulse" />
      </div>

      {/* Benefit chip placeholders */}
      <div className="mt-3 flex flex-wrap items-center gap-1.5">
        <div className="h-[22px] w-16 rounded-full bg-[#EFEDF4] animate-pulse" />
        <div className="h-[22px] w-20 rounded-full bg-[#EFEDF4] animate-pulse" />
        <div className="h-[22px] w-14 rounded-full bg-[#EFEDF4] animate-pulse" />
      </div>

      {/* Footer: "View plan details" link placeholder */}
      <div className="mt-3.5 pt-3 border-t border-[#EFEDF4]">
        <div className="h-3.5 w-28 rounded-full bg-[#EFEDF4] animate-pulse" />
      </div>
    </div>
  );
};

export default PlanCardSkeleton;